import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight, ShieldBan } from "lucide-react";
import { money } from "../../lib/api";

const ACTION_C = { "Approve staged letter": "#FF2BD6", "Review AI draft": "#FFB800", "Collect missing evidence": "#F87171", "Generate AI draft": "#37E5D7", "Awaiting issuer": "#CCFF00" };
const left = (h) => (h < 0 ? "OVERDUE" : h < 48 ? `${h}h left` : `${Math.round(h / 24)}d left`);

export const ActiveDisputes = ({ items, total }) => (
  <section className="panel" data-testid="active-disputes">
    <div className="flex items-center justify-between px-5 py-3 border-b border-line">
      <h3 className="label-xs">My active disputes · what needs action</h3>
      <Link to="/app/disputes" className="font-mono text-[10px] text-white/50 hover:text-brand" data-testid="active-disputes-all">ALL {total} →</Link>
    </div>
    <ul className="divide-y divide-divider">
      {items.map((d) => (
        <li key={d.id}>
          <Link to={`/app/disputes/${d.id}`} className="flex flex-wrap items-center gap-x-5 gap-y-1 px-5 py-3 hover:bg-white/[0.02] transition-colors" data-testid={`active-dispute-${d.id}`}>
            <span className="font-mono text-sm font-bold w-24">{money(d.amount)}</span>
            <span className="text-sm flex-1 min-w-[160px]">{d.reason}<span className="text-white/40"> · {d.customer}</span></span>
            <span className="font-mono text-[11px] text-white/55">WIN {d.predicted_win ?? "—"}%</span>
            <span className={`font-mono text-[10px] ${d.hours_left < 48 ? "text-[#F87171]" : "text-white/45"}`}>{left(d.hours_left)}</span>
            <span className="font-mono text-[10px] tracking-wider px-2 py-1 border" style={{ color: ACTION_C[d.next_action], borderColor: `${ACTION_C[d.next_action]}55` }} data-testid={`active-dispute-action-${d.id}`}>{d.next_action.toUpperCase()}</span>
          </Link>
        </li>
      ))}
    </ul>
  </section>
);

export const InterceptsCard = ({ data }) => (
  <section className="panel h-full" data-testid="intercepts-card">
    <div className="flex items-center justify-between px-5 py-3 border-b border-line">
      <h3 className="label-xs flex items-center gap-2"><ShieldBan className="w-3.5 h-3.5 text-brand" /> Intercepts · {data.count} active</h3>
      <Link to="/app/intercepts" className="font-mono text-[10px] text-white/50 hover:text-brand" data-testid="intercepts-card-all">OPEN →</Link>
    </div>
    <div className="p-5 space-y-4">
      <p className="text-xs text-white/50">Stop chargebacks before they're filed. This is where you save the most.</p>
      {!data.items.length && <p className="text-sm text-white/40">No open alerts right now.</p>}
      {data.items.map((x) => {
        const h = Math.round((new Date(x.expires_at) - Date.now()) / 3600000);
        return (
          <Link key={x.id} to="/app/intercepts" className="block border-l-2 border-brand pl-3 hover:bg-white/[0.02] transition-colors" data-testid={`intercept-card-${x.id}`}>
            <p className="text-sm">{x.customer_name} · {money(x.amount)}</p>
            <p className="font-mono text-[10px] text-white/50 mt-0.5">{x.reason?.replaceAll("_", " ")} · strength {x.strength}% · {x.provider}</p>
            <p className="font-mono text-[10px] mt-1"><span className="text-brand">RECOMMEND: {x.recommendation?.toUpperCase()}</span>
              <span className={h < 12 ? "text-[#F87171]" : "text-white/40"}> · {h > 0 ? `act within ${h}h` : "expired"}</span></p>
          </Link>
        );
      })}
    </div>
  </section>
);

export const StagedBanner = ({ staged }) => staged.count > 0 && (
  <Link to={`/app/disputes/${staged.dispute_ids[0]}`} className="flex items-center gap-3 px-4 py-2.5 border border-[#F87171]/50 bg-[#F87171]/10 text-[#F87171] font-mono text-xs tracking-wider hover:bg-[#F87171]/20 transition-colors" data-testid="staged-review-badge">
    <AlertTriangle className="w-4 h-4" /> {staged.count} STAGED · REVIEW NOW <ArrowRight className="w-3.5 h-3.5" />
  </Link>
);
